// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"app-3DgIpVpZ","detail":"app-2Ihhiptz","row":"app-2Mw91z0d","breadcrumb":"app-2U8e2UKZ","tabs":"app-1wHymFqy","logo":"app-2SBkCwkn","title":"app-2jEuQDyG","action":"app-21rxVa4-","content":"app-35whus4I","extraContent":"app-1Em5KHvm","main":"app-18PZpfCe"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/pageHeader/index.less
// module id = 683
// module chunks = 0